import { Tooltip } from "@material-ui/core";
import React, { useContext } from "react";
import { colours } from "../../../../styles/colours";
import { StakeContext } from "../context";
import { SecondaryTile } from "./secondary-tile";

interface IStatusTileProps { }

const StatusTile: React.FunctionComponent<IStatusTileProps> = (props) => {
  const { currentContract } = useContext(StakeContext);

  return currentContract.fold(
    () => null,
    ({ active }) => (
      <SecondaryTile title="Status">
        <Tooltip title={active ? "Rewards is active" : "Rewards is paused"}>
          <span
            style={{
              color: active ? colours.green : colours.gold,
              fontWeight: 900,
              textTransform: "uppercase",
            }}
          >
            {active ? "active" : "paused"}
          </span>
        </Tooltip>
      </SecondaryTile>
    )
  );
};

export default StatusTile;
